import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const API = axios.create({ baseURL: '/api/v1' });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('gramaayam_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    try {
      const token = localStorage.getItem('gramaayam_token');
      if (!token) { setLoading(false); return; }
      const { data } = await API.get('/auth/me');
      setUser(data.data.user);
    } catch {
      localStorage.removeItem('gramaayam_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = async (email, password) => {
    const { data } = await API.post('/auth/login', { email, password });
    localStorage.setItem('gramaayam_token', data.token);
    setUser(data.data.user);
    return data;
  };

  const register = async (name, email, phone, password) => {
    const { data } = await API.post('/auth/register', { name, email, phone, password });
    localStorage.setItem('gramaayam_token', data.token);
    setUser(data.data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('gramaayam_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, API }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
